import { render } from "./UploadAndCropImage.vue?vue&type=template&id=ae790546"
import script from "./UploadAndCropImage.vue?vue&type=script&lang=js"
export * from "./UploadAndCropImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__